import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { LinkView } from './view/link.js';
import { StatesHeader } from './view/statesheader.js';
import { EditorController } from './view/editor';
import { CrateDecorator } from './view/CrateDecorator';

var debug = require('debug')('CRATE:View');

export var View =
/*#__PURE__*/
function () {
  function View(options, document, editorsContainerID) {
    var _this = this;

    _classCallCheck(this, View);

    this._options = options;
    this._document = document;
    this.crate = this._document.crate;
    this._editorsHolderID = editorsContainerID;
    this._editorContainerID = "container-".concat(this._options.signalingOptions.session);

    this._document.on('FocusIn', function () {
      _this.focusIn();
    });

    this._document.on('FocusOut', function () {
      _this.focusOut();
    });

    this._document.on('UpdateView', function (NumberOfDocuments) {
      debug('UpdateView');

      _this.updateView(NumberOfDocuments);
    });

    this.createCRATE();

    if (this._options.storageServer) {
      this._storageServerState = {};
      this.findremote(true); // join if it is in the sleeping mode to download the last version of the document

      this._timerStorageServer = setInterval(function () {
        return _this.findremote();
      }, 5000);
    }

    var sessionID = this._options.signalingOptions.session;
    /*TODO:
    session.default.getCrateSession(sessionID).goTo(sessionID)
    */
    //TODO:this.viewEditor.focus()

    this._editor = new EditorController(this._document, this._options.signalingOptions.session, this._editorContainerID);
    CrateDecorator.addMoveShortcuts(this.crate);
    CrateDecorator.addResize(this.crate);
  }

  _createClass(View, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      //TODO: session.default.updateViews()
      this._editor.initDocument();
      /**
       * if there are any changes local or remote then we have to wake up the storageServer
       * @param  {[type]} "thereAreChanges" [description]
       * @param  {[type]} (                 [description]
       * @return {[type]}                   [description]
       */


      this._editor.on('thereAreChanges', function () {
        if (_this2._storageServerState === 2) {
          _this2.join();
        }
      });

      $(window).resize(function () {
        $('#comments').height($('#editor').height());
      }); // make title editable

      $("#".concat(this._editorContainerID, " #title")).click(function () {
        $("#".concat(_this2._editorContainerID, " #title")).attr('contenteditable', 'true');
        $(document).on('scroll touchmove mousewheel', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      });
      $("#".concat(this._editorContainerID, " #closeDocument")).click(function () {
        _this2.closeDocument();
      }); //Menu Bar events

      $("#".concat(this._editorContainerID, " #saveicon")).click(function () {
        _this2.saveDocument();
      });
      $("#".concat(this._editorContainerID, " #title")).focusout(function () {
        _this2.changeTitle(); //TODO: this.emit('thereAreChanges')

      });
      var sharingLinkContainer = new LinkView($("#".concat(this._editorContainerID, " #sharinglink")));
      var shareButton = $("#".concat(this._editorContainerID, " #shareicon"));
      this._statesHeader = new StatesHeader(this._document, sharingLinkContainer, shareButton, this._editorContainerID);
      this.documentLoaded();
    }
  }, {
    key: "setMessageState",
    value: function setMessageState(msg) {
      $("#".concat(this._editorContainerID, " #loading h1")).text(msg);
    }
  }, {
    key: "documentLoaded",
    value: function documentLoaded() {
      $("#".concat(this._editorContainerID, " #loading")).hide();
      $("#".concat(this._editorContainerID, " .editorContent")).show();
    }
  }, {
    key: "closeDocument",
    value: function closeDocument() {
      this._document.close();
    }
  }, {
    key: "createCRATE",
    value: function createCRATE() {
      var _this3 = this;

      var html = " \n    <div autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"col-md-10 editorContainer\" id=\"".concat(this._editorContainerID, "\" style=\"width:").concat(this.getWidth(), " !important\" >\n  <!-- editorContent -->\n    <div id=\"loading\" style=\"\n      width: 50%;\n      margin: auto;\n      text-align: center;\n      opacity: 0.5;\n      filter: alpha(opacity=50);\n    \">\n      <img class=\"imageuser\" src=\"/icons/loading.gif\"> \n          \n        <h1 style=\"\n        \n            font-size: xx-large;\n            /* text-align: center; */\n            color: gray;\n          \"></h1>\n    </div>\n      <div class=\"editorContent\" style=\"display: none;\">\n          <!-- Head -->\n          <div id=\"head\">\n          \n          </div><!-- Head -->\n  \n          <div id=\"firstrow\" class=\"row\">\n  \n              <div id=\"title\">\n              ").concat(this._options.name, "\n                  </div>\n  \n                  <div id='menurow'>\n                  <div id=\"features\">\n                  <div id=\"shareicon\">\n                  <i class=\"fa fa-link fa-2x ficon2\"></i>\n                  </div>\n                  <div id=\"saveicon\"><i class=\"fa fa-floppy-o fa-2x ficon2\"></i></div>\n                  <div id=\"remotesave\">\n                  <i class=\"fa fa-cloud fa-2x ficon2\"></i>\n                  </div>\n                  <div id=\"state\">\n                  <i class=\"fa fa-globe fa-2x ficon2 \"></i>\n              </div>\n              \n                  <div id=\"closeDocument\">\n                  <i class=\"fa fa-times-circle fa-2x ficon2\" style=\"\n              \" aria-hidden=\"true\" ></i>\n                  </div>\n              </div>\n              </div>\n              <div id='sharingContainer'> \n              </div>\n          </div>\n          \n          <!-- Content -->\n          <div id=\"content\" class=\"content\">\n              <div id=\"users\" class=\"row\">\n              </div>\n              <div id=\"editorSection\">\n              <div id=\"editor\" class=\"editor\">\n              </div>\n              <div id=\"comments\">\n              </div>\n              </div>\n          </div><!-- Content -->\n  \n          <!-- inputCommentModal -->\n          <div id=\"inputCommentModal\" class=\"modal fade\" role=\"dialog\" style=\"display: none;\">\n              <div class=\"modal-dialog\">\n          \n                  <!-- Modal content-->\n                  <div class=\"modal-content\">\n                      <div class=\"modal-body\">\n                      <button type=\"button\" class=\"close\" data-dismiss=\"modal\">\xD7</button>\n                      <h4>Comment</h4>\n                      <p><textarea name=\"commentInput\" id=\"commentInput\" style=\"width: 100%;\" rows=\"5\"></textarea></p>\n                      </div>\n                      <div class=\"modal-footer\">\n                      <button type=\"button\" class=\"btn btn-default\" id=\"saveComment\"data-dismiss=\"modal\">Save</button>\n                      </div>\n                  </div>\n              \n              </div>\n          </div><!-- inputCommentModal -->\n      </div><!-- editorContent -->\n  </div>\n    ");
      var editorContainer = $("#".concat(this._editorsHolderID));
      editorContainer.append(html);
      $("#".concat(this._editorContainerID, " #saveComment")).click(function () {
        _this3.saveComment();
      });
      $("#".concat(this._editorContainerID, " #remotesave")).click(function () {
        if ($("#".concat(_this3._editorContainerID, " #remotesave")).hasClass('PIN')) {
          _this3.kill();
        } else {
          _this3.join();
        }
      });
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var width = 100;
      var scrollWidth = 0;

      var NumberOfDocuments = this._document.crate.getNumberOfDocuments();

      if (NumberOfDocuments > 1) {
        width = 50;
        scrollWidth = scrollWidth / 2;
      }

      return "calc(".concat(width, "vw - ").concat(scrollWidth, "px)");
    }
  }, {
    key: "saveComment",
    value: function saveComment() {
      this._editor._comments.saveComment();
    }
    /**
     * saveDocument save the document in local storage
     * @return {[type]} [description]
     */

  }, {
    key: "saveDocument",
    value: function saveDocument() {
      if (this._document.saveDocument()) alert('Document is saved successfully');else alert('There is a problem is saving the document');
    }
    /**
     * changeTitle For any change in title, broadcast the new title
     * @return {[type]} [description]
     */

  }, {
    key: "changeTitle",
    value: function changeTitle() {
      $(document).unbind('scroll touchmove mousewheel');
      $("#".concat(this._editorContainerID, " #title")).attr('contenteditable', 'false');

      if ($("#".concat(this._editorContainerID, " #title")).text() == '') {
        $("#".concat(this._editorContainerID, " #title")).text('Untitled document');
      } //TODO: Optimize change only if the text is changed from last state


      this._document._communication.textManager._titleManager.sendChangeTitle($("#".concat(this._editorContainerID, " #title")).text());
    }
  }, {
    key: "focusOut",
    value: function focusOut() {
      $("#container-".concat(this._document.documentId)).removeClass('activeEditor');
      debug('FocusOuT', this._document.documentId);
    }
  }, {
    key: "focusIn",
    value: function focusIn() {
      $("#container-".concat(this._document.documentId)).addClass('activeEditor');
      var moveToIndex = this._document.documentIndex;

      if (moveToIndex >= 1) {
        moveToIndex--;
      }

      var moveToDocumentId = this._document.crate.getDocumentIdFromIndex(moveToIndex);

      if (this._document.crate.getNumberOfDocuments() > 1) {
        $('html, body').animate({
          scrollLeft: $("#container-".concat(moveToDocumentId)).offset().left
        }, 'slow');
      }

      if (this._editor.viewEditor) {
        this._editor.viewEditor.focus();
      }
    }
  }, {
    key: "updateView",
    value: function updateView(numberOfDocuments) {
      debug('uodateView', this._document.documentId);
      $("#".concat(this._editorContainerID)).css('cssText', "width:".concat(this.getWidth(), " !important"));

      if (numberOfDocuments > 1) {
        jQuery("#content-default").css('cssText', "width:calc(".concat(this.getWidth(), " * ").concat(numberOfDocuments, ") !important"));
      }
    }
  }, {
    key: "close",
    value: function close() {
      clearInterval(this._timerStorageServer);

      for (var marker in this._editor.markers) {
        clearInterval(marker.timer);
      } // remove it from the browser


      $("#".concat(this._editorContainerID)).remove();
    } //TODO:Create a special class for remote session

  }, {
    key: "findremote",
    value: function findremote(firsttime) {
      var _this4 = this;

      var sessionID = this._options.signalingOptions.session;
      var remotesave = $("#".concat(this._editorContainerID, " #remotesave")); // There is a configured server

      if (this._options.storageServer) {
        var url = this._options.storageServer + '/exist/' + sessionID;
        fetch(url).then(function (resp) {
          return resp.json();
        }) // Transform the data into json
        .then(function (data) {
          _this4._storageServerState = data.results;

          if (data.results == 0) {
            _this4.unpin(remotesave);
          } else if (data.results == 1) {
            // the session is active on the server
            _this4.pin(remotesave, 'active');
          } else {
            if (firsttime) {
              _this4.join();
            } else {
              _this4.pin(remotesave, 'sleep');
            }
          }
        }).catch(function (thrownError) {
          debug(thrownError);
          clearInterval(_this4._timerStorageServer);

          _this4.unpin(remotesave);
        });
      }
    }
  }, {
    key: "pin",
    value: function pin(remotesave, type) {
      if (type === 'active') {
        remotesave.css('color', 'green');
      } else {
        remotesave.css('color', 'gray');
      }

      remotesave.removeClass('UNPIN');
      remotesave.addClass('PIN');
    }
  }, {
    key: "unpin",
    value: function unpin(remotesave) {
      remotesave.css('color', 'red');
      remotesave.removeClass('PIN');
      remotesave.addClass('UNPIN');
    }
  }, {
    key: "join",
    value: function join() {
      var _this5 = this;

      var sessionID = this._options.signalingOptions.session;
      $.ajax({
        type: 'GET',
        url: this._options.storageServer + '/join/' + sessionID,
        success: function success(data, status) {
          _this5.findremote();
        },
        error: function error() {
          _this5.findremote();
        },
        async: true
      });
    }
  }, {
    key: "kill",
    value: function kill() {
      var _this6 = this;

      var sessionID = this._options.signalingOptions.session;
      var r = confirm('Do you want remove document from remote server!');

      if (r == true) {
        $.ajax({
          type: 'GET',
          url: this._options.storageServer + '/kill/' + sessionID,
          success: function success(data, status) {
            _this6.findremote(sessionID);
          },
          async: false
        });
      }
    }
  }]);

  return View;
}();